import { keepPreviousData, useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { sdk } from "./sdk"

export type Abandoned = {
  id: string
  email: string
  customer_name: string | null
  location: string | null
  items: { id: string; title: string; quantity: number; thumbnail: string | null; unit_price: number }[]
  total: number
  currency_code: string
  created_at: string
  updated_at: string
  recovery_count: number
  recovery_sent_at: string | null
}

export function useAbandoned(p: { q?: string; limit: number; offset: number }) {
  return useQuery({
    queryKey: ["abandoned", p],
    placeholderData: keepPreviousData,
    queryFn: () => sdk.client.fetch<{ checkouts: Abandoned[]; count: number }>("/admin/terify/abandoned", { query: { q: p.q?.trim() || undefined, limit: p.limit, offset: p.offset } }),
  })
}

export function useSendRecovery() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => sdk.client.fetch<{ sent: boolean; recovery_url?: string }>(`/admin/terify/abandoned/${id}/recover`, { method: "POST" }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["abandoned"] }),
  })
}
